import {
  Header,
  HeaderContainer,
  HeaderName,
  HeaderMenuButton,
  HeaderGlobalBar,
  SkipToContent,
  Modal,
  TextInput,
  Form,
  InlineLoading,
} from "@carbon/react";

import { UserAvatar } from "@carbon/icons-react";
import { useUser } from "../../context/UserContext";
import React, { useState, useRef, useEffect } from "react";

import { callApi } from "../../services/apiService";


const PASSWORD_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const isPasswordStrong = (password) =>
  PASSWORD_REGEX.test(password);

export default function Topbar({ onMenuClick, isSidebarOpen }) {
  const { user, logout } = useUser();
  console.log("USER OBJECT:", user);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [openPasswordModal, setOpenPasswordModal] = useState(false);

const [passwordLoading, setPasswordLoading] = useState(false);

const [passwordForm, setPasswordForm] = useState({
  new_password: "",
  confirm_password: "",
});

const [passwordErrors, setPasswordErrors] = useState({});
const [sameAsOldPasswordError, setSameAsOldPasswordError] = useState("");
const profileRef = useRef(null);

useEffect(() => {
  const handleClickOutside = (event) => {
    if (
      profileRef.current &&
      !profileRef.current.contains(event.target)
    ) {
      setShowProfileMenu(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  const handleLogout = () => {
    logout();
    window.location.replace("/login");
  };
 const handlePasswordInputChange = (e) => {
  const { id, value } = e.target;

  setSameAsOldPasswordError("");

  setPasswordForm((prev) => ({
    ...prev,
    [id]: value,
  }));

  if (id === "new_password") {
    if (value && !isPasswordStrong(value)) {
      setPasswordErrors((prev) => ({
        ...prev,
        new_password:
          "Password must contain uppercase, lowercase, number, special character and be at least 8 characters",
      }));
    } else {
      setPasswordErrors((prev) => ({
        ...prev,
        new_password: "",
      }));
    }

    if (
      passwordForm.confirm_password &&
      value !== passwordForm.confirm_password
    ) {
      setPasswordErrors((prev) => ({
        ...prev,
        confirm_password: "Passwords do not match",
      }));
    } else {
      setPasswordErrors((prev) => ({
        ...prev,
        confirm_password: "",
      }));
    }
  }

  if (id === "confirm_password") {
    if (value !== passwordForm.new_password) {
      setPasswordErrors((prev) => ({
        ...prev,
        confirm_password: "Passwords do not match",
      }));
    } else {
      setPasswordErrors((prev) => ({
        ...prev,
        confirm_password: "",
      }));
    }
  }
};

const handlePasswordSubmit = async () => {
  if (!passwordForm.new_password || !passwordForm.confirm_password) {
    setPasswordErrors({
      new_password: !passwordForm.new_password ? "New password is required" : "",
      confirm_password: !passwordForm.confirm_password ? "Confirm password is required" : "",
    });
    return;
  }

  if (!isPasswordStrong(passwordForm.new_password)) return;

  if (passwordForm.new_password !== passwordForm.confirm_password) {
    setPasswordErrors((prev) => ({
      ...prev,
      confirm_password: "Passwords do not match",
    }));
    return;
  }

  try {
    setPasswordLoading(true);
    setSameAsOldPasswordError(""); // NEW — reset before each submit

    const payload = {
      username: user?.email,
      new_password: passwordForm.new_password,
      confirm_password: passwordForm.confirm_password,
    };

    await callApi("POST", "/auth/change-password", payload);

    alert("Password changed successfully");
    setOpenPasswordModal(false);
    setPasswordForm({ new_password: "", confirm_password: "" });
    setPasswordErrors({});
    setSameAsOldPasswordError("");
  } catch (error) {
    const responseData = error?.response?.data || {};
    const status = error?.response?.status || responseData?.status_code;

    const detail =
      responseData?.data?.detail ||
      responseData?.detail ||
      "";

    const normalized = String(detail).toLowerCase();

    // ONLY this case: 400 + "same as old" → inline error below New Password
    if (status === 400 && normalized.includes("same as old")) {
      setSameAsOldPasswordError(
        "New password cannot be the same as old password"
      );
      setPasswordLoading(false);
      return;
    }

    // Everything else — your existing behavior
    console.error(error);
    alert("Unable to change password");
  } finally {
    setPasswordLoading(false);
  }
};
  // Create initials like "JD"
  // const getInitials = (name) => {
  //   if (!name) return "U";
  //   const parts = name.trim().split(" ");
  //   return parts.length > 1
  //     ? parts[0][0] + parts[1][0]
  //     : parts[0][0];
  // };

  // const initials = getInitials(user?.name);

  return (
    <>
    
    <Modal
  open={openPasswordModal}
  modalHeading="Change Password"
  primaryButtonText="Change Password"
  secondaryButtonText="Cancel"
  primaryButtonDisabled={passwordLoading}
  onRequestClose={() => {
  setOpenPasswordModal(false);
  setSameAsOldPasswordError("");
}}
  onRequestSubmit={handlePasswordSubmit}
  preventCloseOnClickOutside
>
  <Form
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    }}
  >
    <div>
    <TextInput
      id="new_password"
      type="password"
      labelText="New Password *"
      value={passwordForm.new_password}
      onChange={handlePasswordInputChange}
      invalid={!!passwordErrors.new_password}
      invalidText={passwordErrors.new_password}
    />

        {sameAsOldPasswordError && (
      <p
        style={{
          fontSize: "0.75rem",
          color: "#da1e28",
          marginTop: "0.25rem",
        }}
      >
        {sameAsOldPasswordError}
      </p>
    )}
  </div>

    <TextInput
      id="confirm_password"
      type="password"
      labelText="Confirm Password *"
      value={passwordForm.confirm_password}
      onChange={handlePasswordInputChange}
      invalid={!!passwordErrors.confirm_password}
      invalidText={passwordErrors.confirm_password}
    />

{passwordLoading ? (
  <InlineLoading description="Changing password..." />
) : (
  <p
    style={{
      fontSize: "0.875rem",
      color: "#6f6f6f",
    }}
  >
    Password must include uppercase, lowercase,
    number, special character and be at least
    8 characters.
  </p>
)}
  </Form>
</Modal>

    <HeaderContainer
  render={() => (
    <Header aria-label={""}>
          <SkipToContent />
          <HeaderMenuButton
            aria-label="Open menu"
            onClick={onMenuClick}
            isActive={isSidebarOpen}
          />

          <HeaderName to="/" prefix={user?.role_name}>
            {""}
          </HeaderName>
        <HeaderGlobalBar>
  <div
    ref={profileRef}
    style={{ position: "relative" }}
  >
<div
  onClick={() => setShowProfileMenu(!showProfileMenu)}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    padding: "0 16px",
    height: "48px",
    userSelect: "none",
  }}
>
  <span
    style={{
      fontSize: "16px",
      fontWeight: 500,
      color: "#161616",
    }}
  >
    User
  </span>

  <UserAvatar size={24} />
</div>

    {showProfileMenu && (
      <div className="profile-dropdown">
        <div className="profile-header">
          <UserAvatar size={32} />

          <div className="profile-info">
            <div className="profile-name">
              {user?.name || "User"}
            </div>

            <div className="profile-email">
              {user?.email}
            </div>
          </div>
        </div>

        



<div
  className="profile-item"
  onClick={() => {
    setShowProfileMenu(false);

    setPasswordForm({
      new_password: "",
      confirm_password: "",
    });

    setPasswordErrors({});
    setSameAsOldPasswordError("");

    setOpenPasswordModal(true);
  }}
>
  Change Password
</div>

        <div
          className="profile-item logout"
          onClick={handleLogout}
        >
          Logout
        </div>
      </div>
    )}
  </div>
</HeaderGlobalBar>
        </Header>
      )}
    />
    </>
  );
}